"use strict";

const isNonNullish = entry => entry !== null && entry !== void 0;
export { isNonNullish };
//# sourceMappingURL=typeGuards.mjs.map
